import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
    name: 'objectToArray'
})

export class ObjectToArrayPipe implements PipeTransform {
    transform(data: Object) {
        return (<any>Object).keys(data).map(key => {
            return {[key]: data[key]}
        })
    }
}
